/**
 * Theme registry — single list of selectable themes. Each `id` is a class applied to <body>; its palette is
 * defined in src/theme (_palette-clinical.scss is the default and needs no class, _palettes-alt.scss holds the rest).
 * Add a theme: define the palette block, then add one entry here — navbar, settings and persistence pick it up.
 */
export interface ThemeDefinition {
  id: string;
  label: string;
}

export const THEMES = [
  { id: 'theme-clinical', label: 'Hospital Green' },
  { id: 'theme-blue', label: 'Hospital Blue' },
] as const satisfies readonly ThemeDefinition[];

export type AppTheme = (typeof THEMES)[number]['id'];

export const DEFAULT_THEME: AppTheme = 'theme-clinical';

/** Every theme class, used to clear the previous one before applying a new one. */
export const THEME_CLASSES: readonly string[] = [...THEMES.map((t) => t.id), 'theme-light'];

/** Saved values from removed themes (dark, hospital, green…) fall back to the default. */
export function resolveTheme(id: string | null | undefined): AppTheme {
  return THEMES.find((t) => t.id === id)?.id ?? DEFAULT_THEME;
}

export function applyThemeClass(body: HTMLElement, theme: AppTheme): void {
  body.classList.remove(...THEME_CLASSES);
  body.classList.add(resolveTheme(theme));
}
